<template>
  <el-dialog title="操作类型" :visible="isShowOperateDialog" width="600px" @open="init" @close="handleClose"
    :close-on-click-modal="false">
    <div>
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="类型" prop="operType">
          <el-select v-model="form.operType" placeholder="--请选择--">
            <el-option v-for="item in optionsList" :label="item.label" :key="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="approveRemark">
          <el-input type="textarea" placeholder="请输入备注" v-model="form.approveRemark" style="width: 90%"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="submitLoading">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    type: {
      type: Number,
      default: 0,
    },
    isShowOperateDialog: {
      type: Boolean,
      default: true
    },
    item: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      submitLoading: false,
      optionsList: [],
      form: {

      },
      rules: {
        operType: [
          { required: true, message: '请选择类型', trigger: 'change' },
        ],
        approveRemark: [
          { required: true, message: '请输入备注', trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    init() {
      if (this.type == 1) {
        this.optionsList = [
          { label: '正常', value: 0 },
          { label: '授信', value: 1 },
          { label: '平移', value: 3 },
          { label: '其他', value: 4 },
        ]
      } else {
        this.optionsList = [
          { label: '正常', value: 0 },
          { label: '还款', value: 2 },
          { label: '平移', value: 3 },
          { label: '其他', value: 4 },
        ]
      }
      this.form = {
        operType: this.item.operType ? this.item.operType : 0,
        approveRemark: this.item.approveRemark
      }
    },
    handleClose() {
      this.form = {
        operType: 0,
        approveRemark: ''
      }
      this.submitLoading = false
      this.$refs['form'].resetFields()
      this.$emit('update:isShowOperateDialog', false)
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.submitLoading = true
          let params = {
            ...this.form,
            orderId: this.id,
          }
          this.$axios
            .get('/depositWithdraw/updateOperType', { params })
            .then(res => {
              this.submitLoading = false
              if (res.code === 200) {
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })
                this.$emit('update:isShowOperateDialog', false)
                this.$bus.$emit('refresh') //通知刷新
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
            .catch(() => {
              this.submitLoading = false
            })
        }
      })
    }
  }
}
</script>